import React from "react";
import { linkifyPlainText } from "../helpers/utils";

const linkClass =
  "underline break-all cursor-pointer hover:opacity-80";

/**
 * Renders plain text with clickable http(s) URLs and phone numbers.
 */
function LinkifiedText({ text, className = "", linkClassName = linkClass }) {
  const segments = linkifyPlainText(text);

  return (
    <span className={className}>
      {segments.map((seg, i) => {
        if (seg.type === "url") {
          return (
            <a
              key={`link-${i}`}
              href={seg.href}
              target="_blank"
              rel="noopener noreferrer"
              className={linkClassName}
            >
              {seg.value}
            </a>
          );
        }
        if (seg.type === "phone") {
          return (
            <a key={`tel-${i}`} href={seg.href} className={linkClassName}>
              {seg.value}
            </a>
          );
        }
        return <React.Fragment key={`text-${i}`}>{seg.value}</React.Fragment>;
      })}
    </span>
  );
}

export default LinkifiedText;
